export const SAVE_VENDOR = "SAVE_VENDOR";
export const VENDOR_LIST = "VENDOR_LIST";
export const VENDOR_DETAILS = "VENDOR_DETAILS";
export const VENDOR_DROPDOWN = "VENDOR_DROPDOWN";